import { ColumnsType } from "../../types/baseTypes";

export const columnSize = (columns: ColumnsType[] | false) => {
  return (
    columns &&
    (columns
      .map((column) =>
        column.breakpoint
          ? `is-${column.number_of_cols}-${column.breakpoint.toLowerCase()}`
          : "",
      )
      .join(" ") as string)
  );
};

export const bulmaColumnsToWidth = (
  number_of_cols: number,
  number_of_total_cols?: number,
) => {
  const totalCols = number_of_total_cols || 12;
  return `${(number_of_cols / totalCols) * 100}%`;
};

export const textColumnSize = ({
  columns,
  columns_text,
}: {
  columns: ColumnsType[] | false;
  columns_text: ColumnsType[] | false;
}) => {
  if (columns && columns_text) {
    let currentTextColumns: ColumnsType = {
      breakpoint: "mobile",
      number_of_cols: 12,
    };
    const textColumnsArr: { breakpoint: string | false; width: string }[] = [];
    // loop through columns and find the columns_text element with same breakpoint, save it to currentTextColumns, calculate with to columns element
    columns.forEach((column) => {
      const textColumn = columns_text.find(
        (text_column) => text_column.breakpoint === column.breakpoint,
      );
      if (textColumn) {
        currentTextColumns = textColumn;
      }
      textColumnsArr.push({
        breakpoint: column.breakpoint,
        width: bulmaColumnsToWidth(
          currentTextColumns.number_of_cols,
          column.number_of_cols,
        ),
      });
    });
    function breakpointsArrayToObject(
      arr: {
        breakpoint: string | false;
        width: string;
      }[],
    ): Record<string, string> {
      return arr.reduce<Record<string, string>>(
        (acc, { breakpoint, width }) => {
          acc[breakpoint as string] = width;
          return acc;
        },
        {},
      );
    }
    return breakpointsArrayToObject(textColumnsArr);
  }
  return undefined;
};
